import { Spinner } from "@heroui/react";
import { Navigate, Outlet } from "react-router";
import { useChildcareAccess } from "@/src/childcare/hooks/use-childcare-access";

/**
 * Second of the three childcare enforcement layers (brief §1): blocks direct
 * navigation to childcare routes for users without access. Nests inside
 * `<ProtectedRoute>` (auth + staff role) and sits above the RLS boundary.
 */
export function ChildcareGuard() {
	const { hasAccess, isLoading } = useChildcareAccess();

	if (isLoading) {
		return (
			<div className="flex min-h-[50vh] items-center justify-center">
				<Spinner />
			</div>
		);
	}

	if (!hasAccess) {
		return <Navigate to="/" replace />;
	}

	return <Outlet />;
}
